import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge, taught this project's scales.
 *
 * The type scale is addressed by role (`text-meta`, `text-display`), and out
 * of the box tailwind-merge reads any unknown `text-*` as a colour. That makes
 * `text-meta` and `text-field` look like two colours on one element, so the
 * later one silently wins and the size is dropped: a badge inside a display
 * heading came out at 34px. Registering the roles as font sizes puts each
 * utility back in its own group.
 *
 * Anything added to the `--text-*` or `--shadow-*` tokens in styles.css has to
 * be listed here too.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display',
            'headline',
            'title',
            'subtitle',
            'prose',
            'support',
            'meta',
            'label',
            'metric',
            'code',
          ],
        },
      ],
      shadow: [{ shadow: ['panel', 'pop'] }],
    },
  },
});

/** Compose class names, then resolve Tailwind conflicts. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
